import { useSelector, shallowEqual } from 'react-redux';

import { NsCheckboxInput } from 'components/common/ns-checkbox-input/NsCheckboxInput';
import { selectPsrPreferences } from 'state/psr/psr-slice';
import { NsSelect } from 'components/common/ns-select/NsSelect';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

import type { PsrItem } from 'config/psr-config';

type Props = {
  psrItem: PsrItem;
  handleSelectPsr: (event: NsInputterEvent) => void;
  handleSelectSubcode: (event: NsInputterEvent) => void;
};

export const PsrInput = ({
  psrItem,
  handleSelectPsr,
  handleSelectSubcode
}: Props) => {
  const { displayName, code, subCode, subCodes, subCodesLabel, type } = psrItem;
  const psrPreferences = useSelector(selectPsrPreferences, shallowEqual);
  const hasSubCodes = Array.isArray(subCodes);
  const psrPref = psrPreferences[type]?.find((psrOption) => {
    if (hasSubCodes) {
      return psrOption.code === code;
    }
    return psrOption.code === code && psrOption.subCode === subCode;
  });
  const key = [type, code, subCode || ''].join('-');
  const name = [type, code, subCode || psrPref?.subCode || ''].join('-');
  const selectValue = psrPref?.subCode ?? '';
  const isChecked = !!psrPref;
  const value = psrPref && key;

  return (
    <>
      <NsCheckboxInput
        testId={displayName.split(' ').join('-')}
        name={name}
        value={value}
        key={value}
        onChange={handleSelectPsr}
        options={[
          {
            label: displayName,
            value: key
          }
        ]}
      />

      {hasSubCodes && isChecked && (
        <NsSelect
          testId={`${displayName} subcodes`.split(' ').join('-')}
          label={subCodesLabel as string}
          name={`${key}-subcode`}
          onChange={handleSelectSubcode}
          value={selectValue}
          validation={[NsInputterValidations.isRequired]}
          options={subCodes.map(({ displayName, subCode }) => ({
            value: subCode,
            text: displayName
          }))}
        />
      )}
    </>
  );
};
